import React, { useEffect, useState, useContext } from "react";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import { useHistory, useParams, useLocation } from "react-router-dom";
import StateContext from "../StateContext";
import Axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import LoaderAnimation from "../Components/LoaderAnimation";
import { Link, NavLink } from "react-router-dom";
import ReviewModal from "../Components/reviewModal/reviewModal";
import ReviewModalv2 from "../Components/reviewModalv2/reviewModalv2";
import DispatchContext from "../DispatchContext";
import Backdrop from "@mui/material/Backdrop";
import { get_lang } from "../../src/Functions/getLang";
import OrderProductv2 from "../Components/OrderProductv2/OrderProductv2";
import OrderStatusV2 from "./orderStatusV2/OrderStatusV2";
import { getLiveData } from "../Components/Pusher";
import { is } from "date-fns/locale";
import { handleGoogleReviewOnload } from "../Functions/googleReview";
import { handleRunServiceWorker } from "../Functions/getPushNotification";
import NotifyPermisssionPopup from "../Components/notifyPermisssionPopup/notifyPermisssionPopup";
import Adds from "../Components/Adds/Adds";
import AddsSlider from "../Components/addsBanners/addsSlider";
import AddsSlider2 from "../Components/addsBanners/addsSlider2";
import RewardPunchPopup from "../Components/rewardPunchPopup/rewardPunchPopup";
import DeliveryStatus from "./deliveryStatus/deliveryStatus";
import { useTranslation, withTranslation } from "react-i18next";
import vendorsConfig from "../vendorsConfig";
import InvoiceDesign from "./InvoiceDesign/InvoiceDesign";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    height: "100vh",
    alignItems: "center",
  },
}));
function Invoice({
  storeInfo,
  invoiceDetail,
  Amount,
  amount: amountProp,
  handleTryAgain,
  eventOrder,
  addsInfo,
  toggleLanguage,
handleProfileClick,
handleShareClick
}) {
  // console.log("invoiceDetail",invoiceDetail)
    const { t } = useTranslation();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();
  const { type, id } = useParams();
  const [paidDate, setPaidDate] = useState("sss");
  const [paidTime, setPaidTime] = useState("ddd");
  const { search, pathname } = useLocation();
  const [timeOut, setTimeOut] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const classes = useStyles();
  const [invoiceDetails, setInvoiceDetails] = useState(invoiceDetail);
  const [amount, setAmount] = useState(amountProp ?? Amount);
  //destructure
  const { invoiceable } = invoiceDetails;
  let selfServe =
    invoiceable?.service_type == "PickUp"
      ? true
      : invoiceable?.info?.qrcode?.section?.hotel?.self_serve ?? false;
  const hasDelivery = invoiceable?.service_type == "Delivery" ? true : false;
  const [orderStatus, setOrderStatus] = useState("Completed");

  const handleOrderStatus = () => {
    if (invoiceDetail?.status == "Paid") {
      let status = invoiceable?.service?.status?.current;
      setOrderStatus(status);
      getLiveData(
        appState,
        appDispatch,
        invoiceDetail.id,
        orderStatus,
        setOrderStatus
      );
    } else if (
      hasDelivery &&
      invoiceDetail?.status !== "Failed" &&
      invoiceDetail?.status !== "Cancelled"
    ) {
      let status = invoiceable?.service?.status?.current;
      setOrderStatus(status);
      getLiveData(
        appState,
        appDispatch,
        invoiceDetail.id,
        orderStatus,
        setOrderStatus
      );
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (invoiceDetails !== null) {
      if (invoiceable?.service?.isOpen == 0 && !eventOrder) {
        handleOrderStatus();
      } else {
        setIsLoading(false);
      }
    } else {
      history.push("/");
    }
  }, []);

 
  // if (isLoading) return <div className={classes.root}><CircularProgress /></div>
  useEffect(() => {
    let checkDeliveryConditions = (invoiceable?.service_type == "Delivery" || invoiceable?.service_type == "PickUp" || invoiceable?.service_type == "Pick-up" ) ? orderStatus == "Completed" : true
    if (invoiceDetails.is_paid && invoiceDetail.isReviewed === false && checkDeliveryConditions && storeInfo?.ratings?.includes(vendorsConfig.SLUG) ) {
      appDispatch({
        type: "setReviewModal",
        reviewModal: true,
      });
    } else if (invoiceDetails.is_paid && invoiceDetail.isReviewed === true || !checkDeliveryConditions || !storeInfo?.ratings?.includes(vendorsConfig.SLUG) ) {
      appDispatch({
        type: "setReviewModal",
        reviewModal: false,
      });
    }
    else{
      appDispatch({
        type: "setReviewModal",
        reviewModal: false,
      });
    }
  }, [invoiceDetail.isReviewed, orderStatus ]);
  

  useEffect(() => {
    if (
      storeInfo?.rating_id != null &&
      invoiceable?.service?.status?.current == "Completed" &&
      invoiceDetail.isReviewed === false
    ) {
      handleGoogleReviewOnload(storeInfo, invoiceDetail);
    }
  }, [invoiceable]);
  useEffect(() => {
    if (appState.reviewModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [appState.reviewModal]);

  if (isLoading)
    return (
      <div className={classes.root}>
        <LoaderAnimation />
      </div>
    );
  return orderStatus != "Completed" && invoiceable?.service_type == "PickUp" && (invoiceDetails.status == "Paid" || invoiceDetails.status == "Direct")? (
    <OrderStatusV2
      invoiceable={invoiceable}
      invoiceDetails={invoiceDetails}
      orderStatus={orderStatus}
      addsInfo={addsInfo}
    />
  ) : orderStatus != "Completed" &&
    invoiceable?.service_type == "Delivery" &&
    invoiceable?.info?.delivery_date != null &&
    (invoiceDetails.status == "Paid" ||
      invoiceDetails.status == "Direct" ||
      (invoiceDetails.status == "Pending" &&
        !(invoiceDetails.is_partial && !invoiceDetails.is_paid))) ? (
    <DeliveryStatus
      invoiceable={invoiceable}
      invoiceDetails={invoiceDetails}
      orderStatus={orderStatus}
      addsInfo={addsInfo}
    />
  ) : (
    <>
      {storeInfo?.ratings?.includes(vendorsConfig.SLUG) && appState.reviewModal && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={invoiceDetails.status === "Paid" && appState.reviewModal}
        ></Backdrop>
      )}
      {/* 
      {((invoiceDetail?.invoiceable?.loyalty_card_punch == null && invoiceDetail?.invoiceable?.loyalty_card_reward !==null && !appState?.reviewModal && invoiceDetail.status === "Paid")) 
      && <RewardPunchPopup storeInfo={storeInfo} invoiceDetail={invoiceDetails} /> } */}
  <InvoiceDesign
    invoiceDetail={invoiceDetail}
    storeInfo={storeInfo}
    currency={storeInfo?.currency}
    amount={amount ?? invoiceable?.amount ?? invoiceDetail?.amount}
    t={t}
    appState={appState}
    appDispatch={appDispatch}
    addsInfo={addsInfo}
    handleTryAgain={handleTryAgain}
    languageLabel={appState.langValue === "ar" ? "English" : "عربي"}
    onLanguageToggle={toggleLanguage}
    onLoginClick={handleProfileClick}
    onShareClick={handleShareClick}
  />
    
    </>
  );
}

export default withTranslation() (Invoice);
